import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import type { TFacebookSettings } from '../../../interfaces/TFacebook';
import { useModal } from '../../modal/useModal';
import { useFacebookPages } from './useFacebookPages';
import { useFacebookPagesActions } from './useFacebookPagesActions';

export const useFacebookSettingsForm = () => {
  const { updateSelectedPageSettings } = useFacebookPagesActions();
  const { facebookPageSettings } = useFacebookPages();

  const defaultValues = useMemo(
    () => facebookPageSettings,
    [facebookPageSettings],
  );

  const { handleSubmit, control, reset } = useForm<TFacebookSettings>({
    shouldUseNativeValidation: true,
    defaultValues: defaultValues,
  });

  useEffect(() => {
    reset(facebookPageSettings);
  }, [facebookPageSettings, reset]);

  const { hideModal } = useModal();

  const hideAndSubmit = async (data: TFacebookSettings) => {
    updateSelectedPageSettings(data);
    hideModal();
  };

  const onSubmit = handleSubmit(hideAndSubmit);

  return {
    onSubmit,
    control,
  };
};
